import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_PRODUCT_DETAIL',
  'CREATE_DOCUMENT_FOLDER',
  'CREATE_DOCUMENT_TAB',
  'UPDATE_DOCUMENT_TAB',
  'DELETE_DOCUMENT_TAB',
  'CREATE_DOCUMENT_FILE',
  'SHARE_FILE_BY_EMAIL',
  'DOCUMENT_BULK_DOWNLOAD',
  'UPDATE_EXPIRY_DATE',
  'UPDATE_REMINDER',
  'DELETE_FILE_OR_FOLDER',
  'RENAME_FILE',
  'RENAME_FOLDER',
  'MOVE_FILE_FOLDER',
  'SEARCH_PRODUCT_FILE'
);
